import { WOW } from "wowjs";

(function ($) {
    $(document).ready(function () {
        const wow = new WOW();

        wow.init();

        let body = $("body");
        let desktopMenuBreakpoint = 1200;

        $(".menu-item-has-children")
            .find(".dropdown-toggle")
            .attr("data-toggle", "");

        /**
         * Back to top button - scroll functionality
         */
        $("#back-to-top").on("click", function () {
            $("html, body").animate(
                {
                    scrollTop: 0,
                },
                400
            );
            return false;
        });
        //show and hide back to top button
        var resizeTimeout;
        $(window).scroll(function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
                if (
                    document.body.scrollTop > 200 ||
                    document.documentElement.scrollTop > 200
                ) {
                    $("#back-to-top").css("opacity", "1");
                } else {
                    $("#back-to-top").css("opacity", "0");
                }
            }, 300);
        });

        /**
         * Add class to body when sticky header is showing
         */
        if ($(window).scrollTop() > 100) {
            body.addClass("sticky-header");
            $("header").addClass("sticked");
        } else {
            body.removeClass("sticky-header");
            $("header").removeClass("sticked");
        }
        $(window).scroll(function () {
            if ($(window).scrollTop() > 100) {
                $("body").addClass("sticky-header");
                $("header").addClass("sticked");
            } else {
                $("body").removeClass("sticky-header");
                $("header").removeClass("sticked");
            }
        });

        /**
         * Mobile menu
         */

        //toggle the 'no-scroll' class on the body when hamburger button is clicked
        $("header .js-mobile-menu-toggle").on("click", function () {
            $("body").toggleClass("no-scroll");
        });

        //find all the sub-menus and add a h4 title to them
        $("#navbarOrange")
            .find(".navbar-nav .menu-item.menu-item-has-children > ul.sub-menu")
            .each(function () {
                if ($(window).width() < desktopMenuBreakpoint) {
                    $(this).addClass("mobile-menu-sub-level-panel");

                    let subLevelTitleElement = $("<h4>").html(
                        $(this).siblings(".nav-link").html().trim()
                    );

                    $(this).prepend(
                        $("<li>")
                            .addClass("menu-item sub-level-panel-heading")
                            .append(subLevelTitleElement)
                    );
                }
            });

        //set a class on mobile nav when opened
        if ($(window).width() < desktopMenuBreakpoint) {
            $("nav.navbar").on("show.bs.collapse", function () {
                $(this).addClass("opened");
            });

            $("nav.navbar").on("hide.bs.collapse", function () {
                $(this).removeClass("opened");
            });
        }

        //set the height of the menu and add the curr-level class
        $("#navbarOrange.navbar-collapse")
            //when the menu opens
            .on("show.bs.collapse", function () {
                let headerBannerHeight = 55;

                //set the CSS variable for the height of the mobile menu
                $(this).css(
                    "--mobile-menu-height",
                    $(window).outerHeight() - headerBannerHeight + "px"
                );

                $(this).children("#menu-wrap").addClass("curr-level");
            })

            //when the menu closes
            .on("hidden.bs.collapse", function () {
                $(this).find(".curr-level").removeClass("curr-level");

                $(this).find(".show").removeClass("show fade-in");

                $(this).find(".mobile-menu-sub-level-panel").scrollTop(0);

                $(this).find(".js-menu-back-btn").data("depth-level", 0);
            });

        let mobileMenuBackBtnWrap = $("#navbarOrange").find(".back-btn-wrap");
        let mobileMenuBackBtn =
            mobileMenuBackBtnWrap.children(".js-menu-back-btn");

        //set the data attribute of the back button to 0. this data doesn't show in the DOM.
        mobileMenuBackBtn.data("depth-level", 0);

        //when the back button is clicked decrease one from the data attribute, find the current level, remove that class and add the curr-level class to it's parrent
        mobileMenuBackBtn.on("click", function () {
            $(this).data("depth-level", $(this).data("depth-level") - 1);

            let currentMenuPanel = $("#navbarOrange").find(
                ".mobile-menu-sub-level-panel.curr-level"
            );

            currentMenuPanel
                .parent()
                .closest(".mobile-menu-sub-level-panel")
                .addClass("curr-level");

            currentMenuPanel
                .addClass("fade-out")
                .removeClass("show fade-in curr-level");

            if ($(this).data("depth-level") <= 0) {
                $("#navbarOrange").find("#menu-wrap").addClass("curr-level");

                $(this)
                    .data("depth-level", 0)
                    .parent()
                    .addClass("fade-out")
                    .removeClass("show fade-in");
            }
        });

        //when a nav-link with sub-menu is clicked set the curr-level class on its sub-menu
        $("#navbarOrange")
            .find(".navbar-nav .menu-item.menu-item-has-children > .nav-link")
            .on("click", function (evt) {
                evt.preventDefault();

                $("#navbarOrange")
                    .find(".curr-level")
                    .removeClass("curr-level");

                $(this)
                    .siblings(".mobile-menu-sub-level-panel")
                    .scrollTop(0)
                    .removeClass("fade-out")
                    .addClass("show fade-in curr-level");

                //if we were on the main level (0) and we're going to level 1 then show the back button
                if (window.innerWidth < desktopMenuBreakpoint) {
                    if (mobileMenuBackBtn.data("depth-level") === 0) {
                        mobileMenuBackBtnWrap
                            .removeClass("fade-out")
                            .addClass("show fade-in");
                    } else {
                        $(this)
                            .siblings(".mobile-menu-sub-level-panel")
                            .css(
                                "top",
                                $(this)
                                    .closest(
                                        ".mobile-menu-sub-level-panel, .header-navbar-menu-inner-wrap"
                                    )
                                    .scrollTop()
                            );
                    }
                }

                //add one to the depth-level data attribute of the back button
                mobileMenuBackBtn.data(
                    "depth-level",
                    mobileMenuBackBtn.data("depth-level") + 1
                );

                return false;
            });
    });
})(jQuery);
